import { BrandKit } from "@redotech/redo-model/brand-kit";
import { SignupForm as ISignupForm } from "@redotech/redo-model/signup-form-schema";
import { memo } from "react";
import { BaseSignupForm } from "./base-signup-form";
import { SignupFormContainer } from "./signup-form-container";

export const SignupForm = memo(function SignupFormModal({
  form,
  brandKit,
  currentStep,
  discountCode,
  merchantPhoneNumber,
  anonymousId,
  onSubmitStep,
  onClose,
}: {
  form: ISignupForm;
  brandKit: BrandKit;
  currentStep: number;
  discountCode?: string;
  merchantPhoneNumber?: string;
  anonymousId?: string;
  onSubmitStep: (_: {
    stepIndex: number;
    formData: Record<string, string>;
    shouldAdvance?: boolean;
  }) => Promise<void>;
  onClose?: () => void;
}) {
  return (
    <SignupFormContainer form={form} onClose={onClose} previewMobile={false}>
      <BaseSignupForm
        anonymousId={anonymousId}
        brandKit={brandKit}
        currentStep={currentStep}
        discountCode={discountCode}
        form={form}
        merchantPhoneNumber={merchantPhoneNumber}
        onClose={onClose}
        onSubmitStep={onSubmitStep}
      />
    </SignupFormContainer>
  );
});
